
"use client"
import React, { useContext, useEffect, useState, useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { Logindetail } from "../context/Logindetail"
import { getInvoiceDown, getShemesSchedule, postMonthShec, SentRequest } from "../api/Pageapi"
import moment from "moment/moment"
import { useRazorpay } from "react-razorpay";
import toast from 'react-hot-toast';
import { Image, Shimmer } from 'react-shimmer'
import { Getdigital_silver_trans, Getdigital_trans } from "../api/RouteScheme2"
import { GetGoldPlantApi } from "../api/RouteScheme3"
import { getCommisionApi, getprofile_fun } from "../api/Dashboardapi"
import { RazarDetails } from "../context/razarApi"
import { SchemeDetails } from "../context/SchemeDetails"
import axios from "axios";
import { capture_payment } from "../api/Controllapi"
import { Snackbar, Alert } from "@mui/material";
import { FaShareAlt } from "react-icons/fa";



export default function ClientDashboard({ setting_data }) {

    //new
    const [new_razar_key, setNew_razar_key] = useState(0)

    const fetchKey = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}razorpay_key`);
            if (response?.data?.razorpay_key) {
                const newKey = response.data.razorpay_key;


                if (newKey) {
                    // Key is different, update state and localStorage
                    setNew_razar_key(newKey);
                    // localStorage.setItem('razorpay_key', newKey);
                }
                // else: keys are same, no update needed
            } else {
                throw new Error("Invalid response format");
            }
        } catch (error) {
            console.error('Failed to fetch Razorpay key:', error);
            // toast.error("Unable to load Razorpay key. Please try again later.");
        }
    };


    // ── Country / State / City lists for franchise dropdown ──────────────────
    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [selectedCountryId, setSelectedCountryId] = useState("");
    const [selectedStateId, setSelectedStateId] = useState("");
    const [showDetails, setShowDetails] = useState(false);
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const responseApi = await axios.get(`${process.env.REACT_APP_BASE_URL}get_country`);
                setCountryList(responseApi?.data?.data || []);
            } catch (err) {
                console.error("Failed to fetch countries:", err);
            }
        };
        fetchCountries();
    }, []);

    // Fetch states when selectedCountryId changes
    useEffect(() => {
        if (!selectedCountryId) {
            setStateList([]);
            return;
        }
        const fetchStates = async () => {
            try {
                const responseApi = await axios.get(`${process.env.REACT_APP_BASE_URL}get_state`, {
                    params: { country_id: selectedCountryId },
                });
                setStateList(responseApi?.data?.data || []);
            } catch (err) {
                console.error("Failed to fetch states:", err);
            }
        };
        fetchStates();
    }, [selectedCountryId]);

    // Fetch cities when both country and state are selected
    useEffect(() => {
        if (!selectedCountryId || !selectedStateId) {
            setCityList([]);
            return;
        }
        const fetchCities = async () => {
            try {
                const responseApi = await axios.get(`${process.env.REACT_APP_BASE_URL}get_city`, {
                    params: {
                        country_id: selectedCountryId,
                        state_id: selectedStateId,
                    },
                });
                setCityList(responseApi?.data?.data || []);
            } catch (err) {
                console.error("Failed to fetch cities:", err);
            }
        };
        fetchCities();
    }, [selectedCountryId, selectedStateId]);
    // ── End Country / State / City setup ─────────────────────────────────────



    useEffect(() => {
        fetchKey()
    }, [])




    //




    // const {} = useContext(RazarDetails)
    //   const new_razar_key = localStorage.getItem('razorpay_key');

    const router = useNavigate()
    const shareCode = async (code) => {
        const message = `Use my referral code: ${code}`;

        if (navigator.share) {
            try {
                await navigator.share({
                    title: "Referral Code",
                    text: message,
                });
            } catch (err) {
            }
        } else {
            navigator.clipboard.writeText(message);
            alert("Referral code copied to share!");
        }
    };


    // const RAZAR_KEY = process.env.REACT_APP_RAZAR_KEY;

    //added key
    const RAZAR_KEY = new_razar_key;


    //default key
    // const RAZAR_KEY = "rzp_live_FZ6iVw5tcRGpW5";


    // const RAZAR_KEY = "rzp_test_K7CipNQYyyMPiS";


    const { token, detail_info, setdetail_info } = useContext(Logindetail)

    const [Shcudle, setShcudle] = useState([])
    const [copied, setCopied] = useState(false);
    const [open, setOpen] = useState(false);
    const { error, isLoading: isRazorpayLoading, Razorpay } = useRazorpay();
    const [showRazorpayModal, setShowRazorpayModal] = useState(false);
    const [shemData, setSchemaData] = useState();
    const [isLoading, setisLoading] = useState(true);
    const [digita_shedule, setdigital_shedule] = useState([])
    const [digital_silver, setDigital_silver] = useState([])
    const [gold_shedule, setgold_shedule] = useState([])

    const [data, setdata] = useState([])
    const [agent_earning, setAgentEarning] = useState(0)
    const [wallet_amount, setWallet_amount] = useState(0)
    const [totalPurchased, setTotalPurchased] = useState(0);
    const reward_eligibility = setting_data?.[0]?.reward_eligibility || "";
    const exclusion = setting_data?.[0]?.exclusion || "";
    const wallet_credit = setting_data?.[0]?.wallet_credit || "";

    // ── Franchise Modal State ──────────────────────────────────────────────────
    const [showFranchiseModal, setShowFranchiseModal] = useState(false);
    const [franchiseSubmitting, setFranchiseSubmitting] = useState(false);
    const initialFranchiseForm = {
        company_name: "",
        gst: "",
        c_country: "",
        c_country_id: "",
        c_state: "",
        c_state_id: "",
        c_city: "",
        c_city_id: "",
        c_postal: "",
        company: "",
        c_address: "",
        c_phone_1: "",
        c_phone_2: "",
    };
    const [franchiseForm, setFranchiseForm] = useState(initialFranchiseForm);
    const [franchiseErrors, setFranchiseErrors] = useState({});

    const validateFranchiseField = (name, value) => {
        switch (name) {
            case "company_name":
                return value.trim() === "" ? "Company name is required." : "";
            case "gst":
                if (value.trim() === "") return "GST number is required.";
                if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value.trim()))
                    return "Invalid GST number format (e.g. 22AAAAA0000A1Z5).";
                return "";
            case "c_country":
                return value.trim() === "" ? "Country is required." : "";
            case "c_city":
                return value.trim() === "" ? "City is required." : "";
            case "c_state":
                return value.trim() === "" ? "State is required." : "";
            case "c_postal":
                if (value.trim() === "") return "Postal code is required.";
                if (!/^[0-9]{4,10}$/.test(value.trim())) return "Enter a valid postal code (4–10 digits).";
                return "";
            // case "company":
            //     return value.trim() === "" ? "Company type is required." : "";
            case "c_address":
                return value.trim() === "" ? "Address is required." : "";
            case "c_phone_1":
                if (value.trim() === "") return "Primary phone is required.";
                if (!/^[6-9][0-9]{9}$/.test(value.trim())) return "Enter a valid 10-digit mobile number.";
                return "";
            // case "c_phone_2":
            //     if (value.trim() !== "" && !/^[6-9][0-9]{9}$/.test(value.trim()))
            //         return "Enter a valid 10-digit mobile number.";
            //     return "";
            default:
                return "";
        }
    };

    const handleFranchiseChange = (e) => {
        const { name, value } = e.target;
        setFranchiseForm((prev) => ({ ...prev, [name]: value }));
        setFranchiseErrors((prev) => ({ ...prev, [name]: validateFranchiseField(name, value) }));
    };

    // Cascading dropdown handlers
    const handleCountryChange = (e) => {
        const selected = countryList.find((c) => String(c.id) === e.target.value);
        setSelectedCountryId(e.target.value);
        setSelectedStateId("");
        setStateList([]);
        setCityList([]);
        setFranchiseForm((prev) => ({
            ...prev,
            c_country: selected?.name || "",
            c_country_id: e.target.value,
            c_state: "",
            c_state_id: "",
            c_city: "",
            c_city_id: "",
        }));
        setFranchiseErrors((prev) => ({ ...prev, c_country: validateFranchiseField("c_country", e.target.value) }));
    };

    const handleStateChange = (e) => {
        const selected = stateList.find((s) => String(s.id) === e.target.value);
        setSelectedStateId(e.target.value);
        setCityList([]);
        setFranchiseForm((prev) => ({
            ...prev,
            c_state: selected?.state || "",
            c_state_id: e.target.value,
            c_city: "",
            c_city_id: "",
        }));
        setFranchiseErrors((prev) => ({ ...prev, c_state: validateFranchiseField("c_state", e.target.value) }));
    };

    const handleCityChange = (e) => {
        const selected = cityList.find((c) => String(c.id) === e.target.value);
        setFranchiseForm((prev) => ({
            ...prev,
            c_city: selected?.city || "",
            c_city_id: e.target.value,
        }));
        setFranchiseErrors((prev) => ({ ...prev, c_city: validateFranchiseField("c_city", e.target.value) }));
    };

    const handleFranchiseSubmit = async (e) => {
        e.preventDefault();
        // Validate fields sequentially to show one toast error at a time
        const fieldsInOrder = [
            "company_name",
            "gst",
            "c_phone_1",
            "c_address",
            "c_country",
            "c_state",
            "c_city",
            "c_postal",
        ];

        for (const key of fieldsInOrder) {
            const err = validateFranchiseField(key, franchiseForm[key]);
            if (err) {
                toast.error(err);
                return;
            }
        }
        setFranchiseSubmitting(true);
        try {
            // Build payload — send IDs for country/state/city
            const payload = {
                company_name: franchiseForm.company_name,
                gst: franchiseForm.gst,
                c_country: franchiseForm.c_country_id,
                c_state: franchiseForm.c_state_id,
                c_city: franchiseForm.c_city_id,
                c_postal: franchiseForm.c_postal,
                company: franchiseForm.company,
                c_address: franchiseForm.c_address,
                c_phone_1: franchiseForm.c_phone_1,
                c_phone_2: franchiseForm.c_phone_2,
            };
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}franchise-request`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            toast.success(response?.data?.message || "Franchise request submitted successfully!");
            getprofile_fun();
            fetchCommision();
            setShowFranchiseModal(false);
            setFranchiseForm(initialFranchiseForm);
            setFranchiseErrors({});
            setSelectedCountryId("");
            setSelectedStateId("");
            setStateList([]);
            setCityList([]);
        } catch (err) {
            toast.error(err?.response?.data?.message || "Failed to submit franchise request.");
        } finally {
            setFranchiseSubmitting(false);

        }
    };
    // ── End Franchise Modal State ──────────────────────────────────────────────





    const copyCode = (code) => {
        navigator.clipboard.writeText(code);
        setCopied(true);
        setOpen(true);

        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") return;
        setOpen(false);
    };



    const fetchCommision = () => {
        setisLoading(true)

        getCommisionApi().then(res => {
            setdata(res.data);
            setisLoading(false)

            setAgentEarning(res?.agent_earning)

        }).catch(err => {
            setisLoading(false)
        })

        getprofile_fun().then(res => {
            const profileData = res?.data;
            setWallet_amount(profileData?.user_wallet || 0)
            // cumulative_amount from profile stores total purchased
            setTotalPurchased(profileData?.cumlative_amount || 0);

            // Sync latest role & profile into context and localStorage
            if (profileData) {
                setdetail_info(profileData);
                const existing = JSON.parse(localStorage.getItem('green_login') || '{}');
                localStorage.setItem('green_login', JSON.stringify({ ...existing, ...profileData }));
            }
        }).catch(err => {
        })
    }


    const handleGetSchema = () => {
        setisLoading(true)
        getShemesSchedule(token).then(res => {
            setShcudle(res);
            setisLoading(false)
        }).catch(err => {
            setisLoading(false)
        })
    }

    const handleDigitalSchmea = () => {
        Getdigital_trans()
            .then((res) => {
                setdigital_shedule(res)
                setisLoading(false)
            })
            .catch((err) => {
                setisLoading(false)
            })
    }

    const handleDigitalSilver = () => {
        Getdigital_silver_trans()
            .then((res) => {
                setDigital_silver(res)
                setisLoading(false)
            })
            .catch((err) => {
                setisLoading(false)
            })
    }

    const handleGoldGetSchema = () => {
        setisLoading(true)
        GetGoldPlantApi(token).then(res => {
            setgold_shedule(res)
            setisLoading(false)
        }).catch(err => {
            setisLoading(false)
        })
    }

    const handlePayment = useCallback(async () => {
        const options = {
            key: RAZAR_KEY,
            amount: (shemData?.amount) * 100,
            currency: "INR",
            name: 'Green Heap',
            description: 'Green Heap',
            image: "/assets/iocns/__Fav Icon.png",
            handler: (res) => {

                const transactionId = res.razorpay_payment_id;
                const clientamount = shemData?.amount

                const body = {
                    "amount": shemData?.amount,
                    "purchase_id": shemData?.id,
                    "transaction_id": res?.razorpay_payment_id,
                }
                postMonthShec(body, token).then(res => {




                    // navigate('/dashboard');
                    handleGetSchema();
                    toast.success("Payment success!")
                    setShowRazorpayModal(false);

                    let resBody = {
                        "paymentId": transactionId,
                        "amount": clientamount
                    }

                    capture_payment(resBody)
                        .then((res) => {
                            // console.log(res)
                        })
                        .catch((e) => {
                        })


                }).catch(err => {
                })
            },
            theme: {
                color: '#650020',
            },

        };

        const rzpay = new Razorpay(options);
        //   console.log(options,"jsgfsfyus fusvfjhsf svgfs")
        rzpay.open();

        // Reset the showRazorpayModal state after payment completion
        rzpay.on('payment.failed', function (response) {
            setShowRazorpayModal(false);
            console.error(response.error.description);
            toast.error(response.error.description)
        });

    }, [shemData]);

    useEffect(() => {
        if (showRazorpayModal) {
            handlePayment();
        }
    }, [showRazorpayModal, handlePayment]);

    useEffect(() => {
        handleGetSchema();
        handleDigitalSchmea()
        handleGoldGetSchema()
        handleDigitalSilver()
        fetchCommision()
    }, []);

    // derived values for wallet offer
    const couponPercentage = setting_data?.[0]?.coupon_amount || 0;
    const targetGoal = setting_data?.[0]?.cumlative_amount || 0;
    const progressPercent = targetGoal > 0 ? Math.min(100, Math.round((totalPurchased / targetGoal) * 100)) : 0;
    const cashbackAmount = ((totalPurchased * couponPercentage) / 100).toFixed(2);
    const walletreturn = (targetGoal * couponPercentage) / 100;

    const handledownload = (value) => {
        const baseurl = process.env.REACT_APP_BASE_URL
        let fileName = `${value?.paid_date}-invoice.pdf`;
        const url = `${baseurl}generate_invoice?id=${value?.id}`;
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch(error => {
                console.error('Error fetching PDF: ', error);
                window.open(url, "_blank");
            });
    }



    // const triggerAgentRequset = () => {

    //     SentRequest(token)
    //         .then((res) => {
    //             if (res.type == 'success') {
    //                 toast.success(res.data)
    //                 document.getElementById('agentBtn').innerText = 'Request submitted';
    //             } else {
    //                 toast.error(res.data)
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //         })

    // }


    const triggerAgentRequset = () => {

        SentRequest(token)
            .then((res) => {
                if (res.type == 'success') {


                    toast.success(res.data)
                    fetchCommision();
                    getprofile_fun();
                    document.getElementById('agentBtn').innerText = 'The request has been sent and is awaiting approval from the administration.';

                    const greenLogin = JSON.parse(localStorage.getItem('green_login'));
                    if (greenLogin.agent_request == 0) {
                        greenLogin.agent_request = 1;
                        localStorage.setItem('green_login', JSON.stringify(greenLogin));
                    }

                } else {
                    toast.error(res.data)
                }
            })
            .catch((err) => {
            })

    }


    // const handlegetprofile = () => {
    //     getprofile_fun()
    //       .then((res) => {
    //         localStorage.setItem("green_login", JSON.stringify(res?.data));
    //         setdetail_info(res?.data)
    //       })
    //       .catch((err) => {
    //         console.log(err)
    //       })
    //   }


    return (
        <>
            <div className="dashbord-content">
                {/* <div className="customer-name">
                {detail_info?.role === 1 && <h4>Referral Code<span> {detail_info?.code} </span></h4>}
            </div> */}


                <Snackbar
                    open={open}
                    autoHideDuration={2000}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={handleClose} severity="success" variant="filled">
                        Referral code copied!
                    </Alert>
                </Snackbar>

                <div className="customer-name">
                    {detail_info?.role === 1 && (
                        <h4>
                            Referral Code
                            <span className="mx-2">{detail_info?.code}</span>

                            {/* Copy Button */}
                            <button
                                className="btn btn-sm ms-2"
                                onClick={() => copyCode(detail_info?.code)}
                                style={{
                                    backgroundColor: '#D4AF37',
                                    borderColor: '#B8960C',
                                    color: '#fff',
                                    fontWeight: '600',
                                    boxShadow: '0 2px 6px rgba(212,175,55,0.4)',
                                }}
                            >
                                📋
                            </button>

                            {/* Share Button */}
                            <button
                                className="btn btn-sm ms-2"
                                onClick={() => shareCode(detail_info?.code)}
                                style={{
                                    backgroundColor: '#4CAF50',
                                    borderColor: '#388E3C',
                                    color: '#fff',
                                    fontWeight: '600',
                                    boxShadow: '0 2px 6px rgba(76,175,80,0.4)',
                                }}
                            >
                                <FaShareAlt />
                                {/* 📤 */}
                            </button>
                        </h4>
                    )}
                </div>


                <div className="customer-balance my-3">
                    <div className="row">
                        {(detail_info?.role == 1 || detail_info?.role == 2) && <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                            <div className="balance-view1 position-relative">
                                <div className="balance-view2">
                                    <div className="balance-view3 d-flex flex-column align-itmes-center justify-content-between position-absolute">
                                        <div className="d-flex align-itmes-center justify-content-between">
                                            <h4>{detail_info?.role === 1 ? 'Agent Earnings' : 'Wallet Amount'}</h4>
                                            <h4>{
                                                isLoading ? <div><Shimmer className="rounded" width={80} height={20} /></div>
                                                    : `₹${detail_info?.role === 1 ? agent_earning : wallet_amount}`
                                            }</h4>
                                        </div>

                                        {detail_info?.role === 1 && (
                                            <div className="d-flex align-itmes-center justify-content-between">
                                                <h4>Wallet Amount</h4>
                                                <h4>{
                                                    isLoading ? <div><Shimmer className="rounded" width={80} height={20} /></div>
                                                        : `₹${wallet_amount}`
                                                }</h4>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>}
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                            <div className="bonus-view">
                                <div className="row">
                                    <div className="col-lg-8 col-md-6 col-sm-8 col-8">
                                        <div className="bonus">
                                            <h4>Welcome</h4>
                                            <h5 className="pb-2 pt-1">Greenheap<span>gold</span></h5>
                                            {
                                                detail_info?.user_type == 0 ? (
                                                    <div className="d-flex flex-row gap-2 align-items-start">
                                                        {/* Agent Section */}
                                                        {detail_info?.role === 1 ? (
                                                            <button className="btn btn-dark text-white text-wrap">You are a Agent</button>
                                                        ) : detail_info?.agent_request === 1 ? (
                                                            <button className="btn btn-dark text-white text-wrap" style={{ cursor: 'default' }}>The agent request has been sent and is awaiting approval from the administration.</button>
                                                        ) : (detail_info?.is_franchise !== 1 && detail_info?.franchise_request !== 1) && (
                                                            <button id="agentBtn" onClick={triggerAgentRequset} className="btn btn-dark text-white">
                                                                Become a Agent
                                                            </button>
                                                        )}

                                                        {/* Franchise Section */}
                                                        {detail_info?.role !== 1 && (
                                                            detail_info?.is_franchise === 1 ? (
                                                                <div className="d-flex flex-row gap-2 align-items-start">
                                                                    <button className="btn btn-dark text-white text-wrap" style={{ cursor: 'default' }}>You are a franchise</button>
                                                                    <button
                                                                        className="btn btn-dark text-white"
                                                                        onClick={() => router("/user/my-franchise")}
                                                                    >
                                                                        My Franchise
                                                                    </button>
                                                                </div>
                                                            ) : detail_info?.franchise_request === 1 ? (
                                                                <button className="btn btn-dark text-white text-wrap" style={{ cursor: 'default' }}>The Franchise request has been sent and is awaiting approval from the administration.</button>
                                                            ) : detail_info?.franchise_request === 2 ? (
                                                                <button className="btn btn-dark text-white text-wrap" onClick={() => setShowFranchiseModal(true)}>Become a Franchise</button>
                                                            ) : !(detail_info?.agent_request === 1) && (
                                                                <button
                                                                    id="franchiseBtn"
                                                                    className="btn btn-dark text-white"
                                                                    onClick={() => setShowFranchiseModal(true)}
                                                                >
                                                                    Become a Franchise
                                                                </button>
                                                            )
                                                        )}
                                                    </div>
                                                ) : (
                                                    <button
                                                        className="btn btn-success text-white"
                                                        onClick={() => router("/user/companyprofile", { state: { type: "Company" } })}
                                                    >
                                                        {detail_info?.user_type == 1 ? "You are a Manufacturer" :
                                                            detail_info?.user_type == 2 ? "You are an Agency" :
                                                                detail_info?.user_type == 3 ? "You are a Dealer" : null}
                                                    </button>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-4 col-4">
                                        <div className="bonus-pic">
                                            <img src="\assets\images\store.png" className="img-fluid" alt="store" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> {/* end .row for customer-balance */}

                    {/* offer/progress section placed above plan cards */}
                    {(detail_info?.role == 1 || detail_info?.role == 2) && (
                        <div className="row mb-4 pt-4">
                            <div className="col-12">
                                <div className="offer-card bg-white p-4 rounded shadow-sm">
                                    {/* <h4 className="mb-2 fw-bold text-dark">
        Reward Coupon
    </h4> */}






                                    {/* Reward Coupon UI Card */}
                                    <div
                                        style={{
                                            marginTop: "15px",
                                            background: "linear-gradient(135deg, #ff4da6, #6a00ff)",
                                            borderRadius: "16px",
                                            padding: "16px",
                                            color: "#fff",
                                            position: "relative",
                                        }}
                                    >
                                        {/* Gift Icon */}
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "-18px",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                background: "#fff",
                                                borderRadius: "50%",
                                                padding: "6px",
                                                fontSize: "18px",
                                            }}
                                        >
                                            🎁
                                        </div>

                                        {/* Dropdown Header */}


                                        <div
                                            className="p-3"
                                            style={{
                                                borderRadius: "10px",
                                                fontSize: "14px",
                                            }}
                                        >
                                            <p className="mb-1 fw-semibold" style={{ color: "#fff" }}>
                                                ✓ {reward_eligibility}
                                            </p>

                                            <p className="mb-1 fw-semibold" style={{ color: "#fff" }}>
                                                ✓ {exclusion}
                                            </p>

                                            <p className="mb-1 fw-semibold" style={{ color: "#fff" }}>
                                                ✓ {wallet_credit}
                                            </p>
                                        </div>
                                        {/* Title and Logo Container */}
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: "8px" }}>
                                            {/* Title */}
                                            <div>
                                                <p style={{ marginBottom: "2px", color: "#fff" }}>Reward Coupon</p>
                                                <p style={{ fontSize: "12px", opacity: 0.8, marginBottom: 0 }}>
                                                    Reward Points Collection
                                                </p>
                                            </div>

                                            {/* Logo + Percentage */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                }}
                                            >
                                                {/* Greenheap Logo */}
                                                <img
                                                    src="/assets/iocns/__Fav%20Icon.png"
                                                    alt="logo"
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        objectFit: "contain",
                                                        marginBottom: "4px",
                                                    }}
                                                />

                                                {/* Percentage */}
                                                <span style={{ fontWeight: "bold", color: "#ffd700" }}>
                                                    {progressPercent || 0}%
                                                </span>
                                            </div>
                                        </div>

                                        {/* Progress Bar */}
                                        <div
                                            style={{
                                                height: "6px",
                                                background: "rgba(255,255,255,0.3)",
                                                borderRadius: "10px",
                                                margin: "10px 0",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: `${progressPercent || 0}%`,
                                                    height: "100%",
                                                    background: "#ffd700",
                                                    borderRadius: "10px",
                                                    transition: "width 0.5s ease",
                                                }}
                                            />
                                        </div>

                                        {/* Target & Reached */}
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                marginTop: "12px",
                                            }}
                                        >

                                            <div
                                                style={{
                                                    background: "rgba(255,255,255,0.15)",
                                                    padding: "10px",
                                                    borderRadius: "10px",
                                                    width: "48%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px"
                                                }}
                                            >
                                                <span style={{ fontSize: "22px", color: "#ffd700" }}>⚑</span>
                                                <div>
                                                    <p style={{ fontSize: "12px", marginBottom: "4px", color: "#fff", opacity: 0.8 }}>Target</p>
                                                    <h6 style={{ margin: 0, color: "#fff" }}>₹ {targetGoal || 0}</h6>
                                                </div>
                                            </div>

                                            <div
                                                style={{
                                                    background: "rgba(255,255,255,0.15)",
                                                    padding: "10px",
                                                    borderRadius: "10px",
                                                    width: "48%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px"
                                                }}
                                            >
                                                {/* <span style={{ fontSize: "22px", color: "#ffd700" }}>✨</span> */}

                                                <span
  style={{
    fontSize: "22px",
    filter: "sepia(1) saturate(5) hue-rotate(10deg)",
  }}
>
  ✨
</span>

                                                <div>
                                                    <p style={{ fontSize: "12px", marginBottom: "4px", color: "#fff", opacity: 0.8 }}>Reached</p>
                                                    <h6 style={{ margin: 0, color: "#fff" }}>₹ {totalPurchased || 0}</h6>
                                                </div>
                                            </div>

                                        </div>
                                        {/* Offer Text */}
                                        <div
                                            style={{
                                                marginTop: "10px",
                                                textAlign: "center",
                                                fontSize: "11px",
                                                opacity: 0.9,
                                                color: "#ffd700"
                                            }}
                                        >
                                            This offer is applicable only for Silver jewellery not for Silver coins and Gold
                                        </div>
                                    </div>




                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="row">
                    <div className=" col-xl-4 col-lg-6 mb-4 col-md-6 col-sm-6" >
                        <div className="post-bg1 d-flex flex-column justify-content-between align-items-end text-end w-100">
                            <div className="totalprop">
                                <span className="one_line">{setting_data[0]?.saving_plan}</span>
                            </div>
                            {
                                isLoading ? <h4>{<Shimmer className="rounded text-end" width={80} height={20} />}</h4> : <h4 className="pt-2 totaltrans">{Shcudle ? Shcudle?.total : '0'}</h4>
                            }
                            <div className="d-flex justify-content-between align-items-center">
                                {/* <h4 className="mb-0">65</h4> */}
                                {/* <img src="/assets/iocns/Buy.png" alt="" /> */}
                                <div></div>
                                <button type="button" onClick={() => router('/user/chit-jewels')} className="btn btn-warning">View All</button>

                            </div>
                        </div>
                    </div>



                    <div className=" col-xl-4 col-lg-6 mb-4 col-md-6 col-sm-6" >
                        <div className="post-bg2 d-flex flex-column justify-content-between align-items-end text-end  w-100">
                            <div className="totalprop">
                                <span className="one_line">{setting_data[0]?.digital_plan}</span>
                            </div>
                            {
                                isLoading ? <h4>{<Shimmer className="rounded" width={80} height={20} />}</h4> : <h4 className=" totaltrans pt-2">{digita_shedule ? digita_shedule?.total : '0'}</h4>
                            }

                            <div className="d-flex justify-content-between align-items-center">
                                <div></div>
                                <button type="button" onClick={() => router('/user/digital-gold')} className="btn btn-warning">View All</button>
                                {/* <img src="/assets/iocns/Buy.png" alt="" /> */}
                            </div>
                        </div>
                    </div>

                    {/* silver plan */}
                    <div className=" col-xl-4 col-lg-6 mb-4 col-md-6 col-sm-6" >
                        <div className="post-bg5 d-flex flex-column justify-content-between align-items-end text-end  w-100">
                            <div className="totalprop">
                                <span className="one_line">{setting_data[0]?.digital_silver_plan}</span>
                            </div>
                            {
                                isLoading ? <h4>{<Shimmer className="rounded" width={80} height={20} />}</h4> : <h4 className=" totaltrans pt-2">{digital_silver ? digital_silver?.total : '0'}</h4>
                            }

                            <div className="d-flex justify-content-between align-items-center">
                                <div></div>
                                <button type="button" onClick={() => router('/user/digital-silver')} className="btn btn-warning">View All</button>
                                {/* <img src="/assets/iocns/Buy.png" alt="" /> */}
                            </div>
                        </div>
                    </div>


                    <div className=" col-xl-4 col-lg-6 mb-4 col-md-6 col-sm-6" >
                        <div className="post-bg3 d-flex flex-column justify-content-between align-items-end text-end  w-100">
                            <div className="totalprop">
                                <span className="one_line">{setting_data[0]?.gold_plant}</span>
                            </div>
                            {
                                isLoading ? <h4>{<Shimmer className="rounded" width={80} height={20} />}</h4> : <h4 className=" totaltrans pt-2">{gold_shedule ? gold_shedule?.total : '0'}</h4>
                            }

                            <div className="d-flex justify-content-between align-items-center">
                                <div></div>
                                <button type="button" onClick={() => router('/user/gold-plant')} className="btn btn-warning">View All</button>
                                {/* <img src="/assets/iocns/Buy.png" alt="" /> */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* { isLoading ?
           <div className="your-sipscheme mb-3"  >
                <div className="sip-title d-flex align-items-center gap-2">
                    <h4 className="m-0"><Shimmer width={130} height={24} /></h4>
                </div>
                <div className="sip-subtitle d-flex align-items-center justify-content-between mt-3">
                    <h4><Shimmer width={200} height={22} /></h4>
                    <h5><Shimmer width={60} height={24} /></h5>
                </div>
                <div className="sip-schemeplan my-2">
                    <div className="row">
                        {
                            Array.from({length : 12}).map((_,i) => (
                                <div className="col-xl-3 col-lg-4 col-sm-6 mb-3" key={i}>
                                <Shimmer width={186} height={68} />
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className="sip-tc">
                    <h5 ><Shimmer width={200} height={24} /></h5>
                </div>
            </div>
         :
            Shcudle?.length > 0 ?
            Shcudle?.map((value, index) => (
                <div className="your-sipscheme mb-3" key={index} onClick={()=> setSchemaData(value)}>
                    <div className="sip-title d-flex align-items-center gap-2">
                        <h4 className="m-0">Your Scheme</h4>
                        {
                         value?.purchase_status == 0 ?
                            <div className="actived-sip d-flex align-items-center gap-2">
                                <img src="\assets\iocns\Tick 1.png" />
                                <h5 className="m-0">Activated</h5>
                            </div> : ''
                        }
                    </div>
                    <div className="sip-subtitle d-flex align-items-center justify-content-between mt-3">
                        <h4>{value?.saving_plan?.title ?? ''}</h4>
                        <h5>₹{value?.amount ?? ''}</h5>
                    </div>
                    <div className="sip-schemeplan my-2">
                        <div className="row">
                            {
                              value?.purchase_transaction?.length > 0 ?
                                value?.purchase_transaction?.map((data, i) => (
                                    <div className=" col-lg-4 col-sm-6" key={i}>
                                        <div className={`plan1  sp${(i+1) > 6 ? (value?.purchase_transaction?.length - i) : i+1} border rounded d-flex align-items-center justify-content-between`}>
                                            <div className="plan-time ">
                                                <p className="fw-bold">Schedule Date :</p>
                                                <p>({data?.schedule_date})</p>
                                            </div>
                                            <div className="plan-rate ">
                                                {
                                                    data?.status == "unpaid" &&  moment(data?.schedule_date, "YYYY-MM-DD").month() == moment(new Date()).month()  ?
                                                    <button type="button" onClick={()=> {setShowRazorpayModal(true)}} className="btn paynsd">PAY NOW</button> :  data?.status == "paid" ?
                                                    <img src="\assets\iocns\invoice.png" onClick={()=> handledownload(data)} className="ytjsfvdjd" />: data?.admin_paid == 1 ?
                                                    <button type="button" disabled className="btn btn-warning">UNPAID</button> : <button type="button" disabled className="btn btn-secondary">UNPAID</button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                ))
                            : ''
                            }
                        </div>
                    </div>
                    <div className="sip-tc">
                        <h5 >T&C* Apply Minimum 1gram Above Applicable</h5>
                    </div>
                </div>
            ))
            : ''
        } */}

            </div>

            {/* ── Franchise Request Modal ────────────────────────────────────────── */}
            {showFranchiseModal && (
                <div
                    style={{
                        position: "fixed", inset: 0, zIndex: 9999,
                        background: "rgba(0,0,0,0.55)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        padding: "16px",
                    }}
                    onClick={(e) => { if (e.target === e.currentTarget) { setShowFranchiseModal(false); setFranchiseErrors({}); setFranchiseForm(initialFranchiseForm); setSelectedCountryId(""); setSelectedStateId(""); setStateList([]); setCityList([]); } }}
                >
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "14px",
                            width: "100%",
                            maxWidth: "640px",
                            maxHeight: "90vh",
                            overflowY: "auto",
                            boxShadow: "0 24px 64px rgba(0,0,0,0.25)",
                            animation: "franchiseSlideIn 0.28s cubic-bezier(.4,0,.2,1)",
                        }}
                    >
                        {/* Header */}
                        <div
                            style={{
                                background: "linear-gradient(135deg, #f7f3f3 0%, #f4dac5 100%)",
                                borderRadius: "14px 14px 0 0",
                                padding: "20px 24px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <div>
                                <h5 style={{ color: "#D4AF37", margin: 0, fontWeight: 700, letterSpacing: "0.5px" }}>Become a Franchise</h5>
                                <p style={{ color: "#0a0a0a", margin: 0, fontSize: "13px", marginTop: "2px" }}>Fill in your company details to submit a franchise request.</p>
                            </div>
                            <button
                                onClick={() => { setShowFranchiseModal(false); setFranchiseErrors({}); setFranchiseForm(initialFranchiseForm); setSelectedCountryId(""); setSelectedStateId(""); setStateList([]); setCityList([]); }}
                                style={{
                                    background: "rgba(86, 156, 214, 0.12)",
                                    border: "none",
                                    color: "#0d0d0d",
                                    width: 34, height: 34,
                                    borderRadius: "50%",
                                    fontSize: "18px",
                                    cursor: "pointer",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    transition: "background 0.2s",
                                }}
                                aria-label="Close"
                            >
                                &times;
                            </button>
                        </div>

                        {/* Body */}
                        <form onSubmit={handleFranchiseSubmit} noValidate style={{ padding: "24px" }}>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                                {/* Rejection Remark */}
                                {detail_info?.franchise_request === 2 && (
                                    <div style={{ gridColumn: "1 / -1" }}>
                                        <div className="alert alert-danger mb-0 py-2 px-3 w-100">
                                            <strong><i className="fa fa-exclamation-circle me-2"></i>Franchise Request Rejected:</strong>
                                            <p className="mb-0 mt-2">{detail_info?.franchise_ramark || "No remarks provided."}</p>
                                        </div>
                                    </div>
                                )}

                                {/* Company Name */}
                                <div style={{ gridColumn: "1 / -1" }}>
                                    <label style={franchiseLabelStyle}>Company Name <span style={{ color: "#e53935" }}>*</span></label>
                                    <input
                                        type="text" name="company_name" value={franchiseForm.company_name}
                                        onChange={handleFranchiseChange}
                                        placeholder="Enter company name"
                                        style={franchiseInputStyle(franchiseErrors.company_name)}
                                    />
                                    {/* {franchiseErrors.company_name && <span style={franchiseErrStyle}>{franchiseErrors.company_name}</span>} */}
                                </div>

                                {/* GST */}
                                <div>
                                    <label style={franchiseLabelStyle}>GST Number <span style={{ color: "#e53935" }}>*</span></label>
                                    <input
                                        type="text" name="gst" value={franchiseForm.gst}
                                        onChange={handleFranchiseChange}
                                        placeholder="e.g. 22AAAAA0000A1Z5"
                                        style={franchiseInputStyle(franchiseErrors.gst)}
                                        maxLength={15}
                                    />
                                    {/* {franchiseErrors.gst && <span style={franchiseErrStyle}>{franchiseErrors.gst}</span>} */}
                                </div>

                                {/* Company Type */}
                                {/* <div>
                                    <label style={franchiseLabelStyle}>Company Type <span style={{ color: "#e53935" }}>*</span></label>
                                    <input
                                        type="text" name="company" value={franchiseForm.company}
                                        onChange={handleFranchiseChange}
                                        placeholder="e.g. Pvt Ltd, LLP"
                                        style={franchiseInputStyle(franchiseErrors.company)}
                                    />
                                    {franchiseErrors.company && <span style={franchiseErrStyle}>{franchiseErrors.company}</span>}
                                </div> */}

                                {/* Country */}
                                <div>
                                    <label style={franchiseLabelStyle}>Country <span style={{ color: "#e53935" }}>*</span></label>
                                    <select
                                        required
                                        value={selectedCountryId}
                                        onChange={handleCountryChange}
                                        style={{ ...franchiseInputStyle(franchiseErrors.c_country), color: '#000' }}
                                        className="text-dark"
                                    >
                                        <option value="" style={{ color: '#000' }}>-- Select Country --</option>
                                        {countryList.map((c) => (
                                            <option key={c.id} value={c.id} style={{ color: '#000' }}>{c.name}</option>
                                        ))}
                                    </select>
                                    {/* {franchiseErrors.c_country && <span style={franchiseErrStyle}>{franchiseErrors.c_country}</span>} */}
                                </div>

                                {/* State */}
                                <div>
                                    <label style={franchiseLabelStyle}>State <span style={{ color: "#e53935" }}>*</span></label>
                                    <select
                                        required
                                        value={selectedStateId}
                                        onChange={handleStateChange}
                                        disabled={!selectedCountryId}
                                        style={{ ...franchiseInputStyle(franchiseErrors.c_state), color: '#000' }}
                                        className="text-dark"
                                    >
                                        <option value="" style={{ color: '#000' }}>-- Select State --</option>
                                        {stateList.map((s) => (
                                            <option key={s.id} value={s.id} style={{ color: '#000' }}>{s.state}</option>
                                        ))}
                                    </select>
                                    {/* {franchiseErrors.c_state && <span style={franchiseErrStyle}>{franchiseErrors.c_state}</span>} */}
                                </div>

                                {/* City */}
                                <div>
                                    <label style={franchiseLabelStyle}>City <span style={{ color: "#e53935" }}>*</span></label>
                                    <select
                                        required
                                        value={franchiseForm.c_city_id}
                                        onChange={handleCityChange}
                                        disabled={!selectedStateId}
                                        style={{ ...franchiseInputStyle(franchiseErrors.c_city), color: '#000' }}
                                        className="text-dark"
                                    >
                                        <option value="" style={{ color: '#000' }}>-- Select City --</option>
                                        {cityList.map((c) => (
                                            <option key={c.id} value={c.id} style={{ color: '#000' }}>{c.city}</option>
                                        ))}
                                    </select>
                                    {/* {franchiseErrors.c_city && <span style={franchiseErrStyle}>{franchiseErrors.c_city}</span>} */}
                                </div>

                                {/* Postal Code */}
                                <div>
                                    <label style={franchiseLabelStyle}>Postal Code <span style={{ color: "#e53935" }}>*</span></label>
                                    <input
                                        type="text" name="c_postal" value={franchiseForm.c_postal}
                                        onChange={handleFranchiseChange}
                                        placeholder="e.g. 600001"
                                        style={franchiseInputStyle(franchiseErrors.c_postal)}
                                        maxLength={10}
                                        inputMode="numeric"
                                    />
                                    {/* {franchiseErrors.c_postal && <span style={franchiseErrStyle}>{franchiseErrors.c_postal}</span>} */}
                                </div>

                                <div>
                                    <label style={franchiseLabelStyle}>Primary Phone <span style={{ color: "#e53935" }}>*</span></label>
                                    <input
                                        type="tel" name="c_phone_1" value={franchiseForm.c_phone_1}
                                        onChange={handleFranchiseChange}
                                        placeholder="10-digit mobile"
                                        style={franchiseInputStyle(franchiseErrors.c_phone_1)}
                                        maxLength={10}
                                        inputMode="numeric"
                                    />
                                    {/* {franchiseErrors.c_phone_1 && <span style={franchiseErrStyle}>{franchiseErrors.c_phone_1}</span>} */}
                                </div>

                                {/* Address */}
                                <div style={{ gridColumn: "1 / -1" }}>
                                    <label style={franchiseLabelStyle}>Company Address <span style={{ color: "#e53935" }}>*</span></label>
                                    <textarea
                                        name="c_address" value={franchiseForm.c_address}
                                        onChange={handleFranchiseChange}
                                        placeholder="Enter full address"
                                        rows={2}
                                        style={{ ...franchiseInputStyle(franchiseErrors.c_address), resize: "vertical" }}
                                    />
                                    {/* {franchiseErrors.c_address && <span style={franchiseErrStyle}>{franchiseErrors.c_address}</span>} */}
                                </div>

                                {/* Phone 1 */}


                                {/* Phone 2 */}
                                {/* <div>
                                    <label style={franchiseLabelStyle}>Secondary Phone <span style={{ color: "#888", fontSize: "11px" }}>(optional)</span></label>
                                    <input
                                        type="tel" name="c_phone_2" value={franchiseForm.c_phone_2}
                                        onChange={handleFranchiseChange}
                                        placeholder="Alternate mobile (optional)"
                                        style={franchiseInputStyle(franchiseErrors.c_phone_2)}
                                        maxLength={10}
                                        inputMode="numeric"
                                    />
                                    {franchiseErrors.c_phone_2 && <span style={franchiseErrStyle}>{franchiseErrors.c_phone_2}</span>}
                                </div> */}

                            </div>

                            {/* Footer Buttons */}
                            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "24px" }}>
                                <button
                                    type="button"
                                    onClick={() => { setShowFranchiseModal(false); setFranchiseErrors({}); setFranchiseForm(initialFranchiseForm); setSelectedCountryId(""); setSelectedStateId(""); setStateList([]); setCityList([]); }}
                                    style={{
                                        padding: "10px 24px", borderRadius: "8px",
                                        border: "1.5px solid #ccc", background: "#f5f5f5",
                                        color: "#555", fontWeight: 600, cursor: "pointer",
                                        fontSize: "14px", transition: "all 0.2s",
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={franchiseSubmitting}
                                    style={{
                                        padding: "10px 28px", borderRadius: "8px",
                                        border: "none",
                                        background: franchiseSubmitting
                                            ? "#999"
                                            : "linear-gradient(135deg, #1a1a1a 0%, #3d1c00 100%)",
                                        color: "#D4AF37", fontWeight: 700,
                                        cursor: franchiseSubmitting ? "not-allowed" : "pointer",
                                        fontSize: "14px", letterSpacing: "0.4px",
                                        transition: "all 0.2s",
                                    }}
                                >
                                    {franchiseSubmitting ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>

                    <style>{`
                        @keyframes franchiseSlideIn {
                            from { opacity: 0; transform: translateY(-28px) scale(0.97); }
                            to   { opacity: 1; transform: translateY(0) scale(1); }
                        }
                    `}</style>
                </div>
            )}
            {/* ── End Franchise Request Modal ─────────────────────────────────────── */}
        </>
    )
}

// ── Style helpers (defined outside component for performance) ──────────────────
const franchiseLabelStyle = {
    display: "block", fontSize: "13px", fontWeight: 600,
    color: "#333", marginBottom: "5px",
};
const franchiseInputStyle = (hasError) => ({
    width: "100%", padding: "9px 12px",
    borderRadius: "8px",
    border: `1.5px solid ${hasError ? "#e53935" : "#ddd"}`,
    fontSize: "14px", color: "#222",
    outline: "none",
    background: hasError ? "#fff5f5" : "#fafafa",
    transition: "border-color 0.2s",
    boxSizing: "border-box",
});
const franchiseErrStyle = {
    display: "block", color: "#e53935",
    fontSize: "11.5px", marginTop: "3px",
};

